export const Table = ({ children }) => {
  return <table class="table table-striped">{children}</table>;
};

export const TableBody = ({ children }) => {
  return <tbody>{children}</tbody>;
};

export const TableHead = ({ children }) => {
  return <thead>{children}</thead>;
};

export const TableRow = ({ children, onClick }) => {
  return <tr onClick={onClick}>{children}</tr>;
};

export const TableCell = ({ children }) => {
  return <td>{children}</td>;
};

export const TableKeyValue = ({ label, children }) => {
  return (
    <TableRow>
      <th>{label}</th>
      <TableCell>{children}</TableCell>
    </TableRow>
  );
};
